const STORAGE_PREFIX = "setup_workflow_";

/**
 * Save setup wizard data for a given step key. Keys are plain strings so each app
 * (backoffice, reseller, …) can define its own step names without a shared enum.
 * The prefix is fixed and shared safely across apps: localStorage is per-origin,
 * so there is no collision risk between them.
 */
export const saveSetupData = (key: string, data: unknown): void => {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(data));
  } catch (error) {
    console.error(`Error saving setup data for ${key}:`, error);
  }
};

/**
 * Retrieve setup wizard data for a given step key.
 */
export const getSetupData = <T = unknown>(key: string): T | null => {
  try {
    const data = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
    if (!data) return null;
    return JSON.parse(data) as T;
  } catch (error) {
    console.error(`Error retrieving setup data for ${key}:`, error);
    return null;
  }
};

/**
 * Clear setup wizard data for the given step keys.
 */
export const clearSetupData = (keys: string[]): void => {
  try {
    keys.forEach((key) => localStorage.removeItem(`${STORAGE_PREFIX}${key}`));
  } catch (error) {
    console.error("Error clearing setup data:", error);
  }
};

/**
 * Check if any setup wizard data exists for the given step keys.
 */
export const hasSetupData = (keys: string[]): boolean => {
  return keys.some(
    (key) => localStorage.getItem(`${STORAGE_PREFIX}${key}`) !== null,
  );
};
